import styled from 'styled-components';
import ButtonLink from '../shared/ButtonLinkComponent';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { device } from '../../utils/styled-component-mixins';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';

const FlexibleBannerWrapper = styled.div`
  ${(props) =>
    props.backgroundImage && `background: url("${props.backgroundImage}") center/cover no-repeat;`}
  align-items: center;
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.layout === '2' ? 'space-between' : 'center')};
  padding: 4rem 1.6rem;
  width: 100%;
  ${(props) => props.layout === 'shadowed' && 'box-shadow: 0px 16px 80px rgba(91, 110, 127, 0.25);'}
  ${(props) => props.layout === '1' && 'flex-direction: column;'}

  @media ${device.desktop} {
    padding: 8rem;
    ${(props) =>
      props.buttonSide === 'left' && props.layout === '2' && 'flex-direction: row-reverse;'}
    ${(props) => props.buttonSide === 'right' && props.layout === '2' && 'flex-direction: row;'}
  }

  .flexible-banner-buttons {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;

    @media ${device.tablet} {
      width: auto;
    }

    a {
      align-items: center;
      display: flex;
      justify-content: center;
      width: 100%;

      @media ${device.tablet} {
        width: auto;
      }
    }

    > div:nth-child(2) .btn-wrapper {
      margin-top: 2rem;
    }
  }

  .flexible-banner-content {
    ${(props) => props.theme === 'dark' && `color: var(--white);`}
    margin-bottom: 4rem;

    @media ${device.desktop} {
      ${(props) => (props.layout !== '2' ? 'margin-bottom: 4rem;' : 'margin-bottom: 0;')}
      ${(props) => props.layout === '2' && 'width: 60%;'}
    }
  }
`;

const FlexibleBannerComponent = (props) => {
  const {
    backgroundImage,
    buttonSide,
    content,
    layout,
    lightDarkTheme,
    isExternal,
    primaryButtonLinkTarget,
    primaryButtonText,
    primaryButtonType,
    primaryButtonUrl,
    primaryButtonIcon,
    secondaryButtonLinkTarget,
    secondaryButtonText,
    secondaryButtonType,
    secondaryButtonUrl,
    secondaryButtonIcon,
    secondaryButtonIsExternal,
    widgetID
  } = props;

  return (
    <WidgetIdWrapper widgetID={widgetID}>
      <FlexibleBannerWrapper
        layout={layout}
        buttonSide={buttonSide}
        backgroundImage={backgroundImage}
        theme={lightDarkTheme}
      >
        <div
          className="flexible-banner-content"
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
        <div className="flexible-banner-buttons">
          {primaryButtonText && (
            <ButtonLink
              link={primaryButtonUrl}
              isExternal={isExternal}
              target={primaryButtonLinkTarget}
              type={primaryButtonType}
              text={primaryButtonText}
              icon={primaryButtonIcon}
              theme={lightDarkTheme}
            />
          )}
          {secondaryButtonText && (
            <ButtonLink
              link={secondaryButtonUrl}
              isExternal={secondaryButtonIsExternal}
              target={secondaryButtonLinkTarget}
              type={secondaryButtonType}
              text={secondaryButtonText}
              icon={secondaryButtonIcon}
              theme={lightDarkTheme}
            />
          )}
        </div>
      </FlexibleBannerWrapper>
    </WidgetIdWrapper>
  );
};

export default withWidgetSpacingWrapper(FlexibleBannerComponent);
